import React, { FC, Fragment, memo } from "react";
import { questionHasChildren, QuestionProjection } from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { useQuestionItem } from "@lookiero/sty-psp-quiz-style-profile-common-ui/dist/src/infrastructure/ui/components/organisms/question/behaviours/useQuestionItem";
import { Divider } from "../../../../components/atoms/divider/Divider";
import { useStaticInfo } from "../../../../hooks/useStaticInfo";
import { DOMAIN } from "../../../../i18n/i18n";

interface QuestionProps {
  readonly questionParentId: string;
  readonly question: QuestionProjection;
}

const Question: FC<QuestionProps> = ({ question, questionParentId }) => {
  const Item = useQuestionItem({ type: question.type });
  const {
    customer: { country, segment },
    tradename,
  } = useStaticInfo();

  return (
    <Item
      country={country}
      domain={DOMAIN}
      question={question}
      questionParentId={questionParentId}
      segment={segment}
      tradename={tradename}
    >
      {questionHasChildren(question) &&
        question.children.map((childQuestion, index) => (
          <Fragment key={childQuestion.id}>
            <Question question={childQuestion} questionParentId={question.id} />
            {index < question.children.length - 1 && <Divider />}
          </Fragment>
        ))}
    </Item>
  );
};

const memoizedQuestion = memo(Question);
export { memoizedQuestion as Question };
